// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchInput_wrapper__2dGqy","icon":"SearchInput_icon__3kBJg","input":"SearchInput_input__3LHqP"};